module.exports = __webpack_public_path__ + "static/media/Jason-Williams-2.792cb615.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/leadership/Jason-Williams-2.png
// module id = 284
// module chunks = 0